import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16">
      <div className="text-center max-w-md space-y-6">
        <div className="inline-flex items-center justify-center bg-rose-50 text-rose-600 h-20 w-20 rounded-full text-4xl mb-2 border border-rose-100">
          <i className="fa-solid fa-lock"></i>
        </div>
        <div className="space-y-2">
          <h1 className="text-4xl font-extrabold text-brand-dark tracking-tight">403 - Adgang nægtet</h1>
          <p className="text-slate-600 text-sm leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side. Området er afspærret af sikkerhedsmæssige årsager.
          </p>
        </div>
        <div className="pt-4 flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/"
            className="bg-brand-orange hover:bg-brand-orange-hover text-white font-bold py-3 px-6 rounded-lg transition-colors shadow-sm text-sm flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house"></i>
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="border border-slate-300 hover:border-slate-400 text-slate-700 font-bold py-3 px-6 rounded-lg transition-colors text-sm flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-envelope"></i>
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
